module.exports = __webpack_public_path__ + "static/media/CUB.fb5dbc8b.svg";